import React, { useEffect, useState } from "react";
import { BiVideoPlus } from "react-icons/bi";
import Person from "../../assets/newicons/inperson.svg";
import view from "../../assets/newicons/eye1.svg";
import { LiaPrescriptionSolid } from "react-icons/lia";
import { RiFlaskLine } from "react-icons/ri";
import { IoFlaskOutline } from "react-icons/io5";
import ViewPrescription from "../MedicalRecords/MyPrescription/ViewPrescription";
import { message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const PrescriptionCard = ({
  aptid,
  pres,
  name,
  doctor,
  reason,
  clinic,
  date,
  patientImage,
  doctorImage,
}) => {
  const [selectedPresc, setSelectedPresc] = useState({
    data: null,
    modal: false,
  });
  const handleViewPres = (presc) => {
    setSelectedPresc({
      ...selectedPresc,
      data: presc,
      modal: true,
    });
  };
  const handlePrescModalClose = () => {
    setSelectedPresc({
      ...selectedPresc,
      data: null,
      modal: false,
    });
  };
  return (
    <>
      <div className="bg-white shadow rounded-xl border mb-4">
        <div className="flex items-center justify-between p-3 border-b">
          <span className="text-xs font-medium font-sans text-[#333333]">
            {name}
          </span>
          <span className="text-xs font-sans text-[#333333] font-semibold">
            APT-{aptid}
          </span>
          <button
            onClick={() => {
              handleViewPres(pres);
            }}
            className="w-28 h-6 bg-[#189FAA] text-white font-sans font-medium text-xs rounded-md"
          >
            View prescription
          </button>
        </div>
        <div className="p-3 space-y-2">
          <div className="flex items-center gap-2">
            {/* <img
              src={patientImage}
              alt="patient"
              className="w-8 h-8 rounded-full"
            /> */}
          </div>
          {/* <div className="flex items-center gap-2">
            <img
              src={doctorImage}
              alt="doctor"
              className="w-8 h-8 rounded-full"
            />
           
          </div> */}{" "}
          <span className="text-xs font-medium font-sans bg-[#E7EEFF] text-[#333333] px-2 py-0.5 rounded">
            {doctor}
          </span>
          <div className="text-xs font-medium font-sans text-[#333333]">
            <span className="text-xs font-medium font-sans text-[#828282]">
              Reason:
            </span>{" "}
            {reason}
          </div>
          <div className="flex gap-5 pt-2  border-t">
            <span className="flex items-center mt-1 justify-center rounded-md gap-2 text-xs font-medium font-sans text-[#333333]  w-24 h-5">
              {clinic}
            </span>
            <span className="border-l-2 border"></span>
            <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
              {dayjs(date).format("DD/MM/YYYY")}
            </span>
          </div>
        </div>
      </div>
      <Modal
        open={selectedPresc.modal}
        onCancel={handlePrescModalClose}
        footer={[]}
        destroyOnClose
        width={"70%"}
      >
        <ViewPrescription prescription={selectedPresc.data} />
      </Modal>
    </>
  );
};

function MedicalRecords({ prescriptionsList, labData, profileImage }) {
  const [activeTab, setActiveTab] = useState("prescription");
  const navigate = useNavigate();
  const [selectedLabRep, setSelectedLabRep] = useState({
    data: null,
    modal: false,
  });
  const [formattedDates, setFormattedDates] = useState([]);
  const formatDate = (dateTime) => {
    if (dateTime) {
      const date = new Date(dateTime);
      return date.toISOString().split("T")[0];
    }
  };

  const handleLabRepView = (labRep) => {
    const url = labRep?.resultDocumentName;

    if (!url) {
      message.error("Document not available");
      return;
    }
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.open(url, "_blank");
      return;
    } else {
      setSelectedLabRep({
        ...selectedLabRep,
        data: labRep?.resultDocumentName,
        modal: true,
      });
    }
  };
  const handleLabModalClose = () => {
    setSelectedLabRep({
      ...selectedLabRep,
      data: null,
      modal: false,
    });
  };
  useEffect(() => {
    if (!prescriptionsList || !Array.isArray(prescriptionsList)) {
      console.error("Invalid prescription data format");
      return;
    }

    const formatPresDates = () => {
      return prescriptionsList.map((pres) => {
        try {
          if (!pres.consultationDate) {
            console.warn("Missing consultation date:", pres.id);
            return "Invalid date";
          }

          // Split date and time first
          const [datePart] = pres.consultationDate.split(" ");
          const [year, month, day] = datePart.split("-");

          // Validate parts
          if (!year || !month || !day) {
            throw new Error(`Invalid date format for ID ${pres.id}`);
          }

          // Create date object (months are 0-indexed)
          const date = new Date(year, month - 1, day);

          if (isNaN(date)) {
            throw new Error(`Invalid date values for ID ${pres.id}`);
          }

          const formattedDate = date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          });

          return formattedDate;
        } catch (error) {
          console.error(`Error processing prescription ${pres.id}:`, error);
          return "Invalid date format";
        }
      });
    };

    setFormattedDates(formatPresDates());
  }, [prescriptionsList]);

  const handleClick = () => {
    if (activeTab === "prescription") {
      navigate("/myprescription");
    } else {
      navigate("/myreports");
    }
  };

  return (
    <>
      <div
        className="p-4 bg-white rounded-xl shadow-md border h-80 overflow-y-scroll"
        id="unquie-scroll"
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex gap-5 items-center">
            <h2 className="text-sm font-semibold text-[#D8383A] font-sans">
              Medical Records
            </h2>
            <div className="flex gap-3">
              <p
                className={`rounded-full w-8 h-8 flex items-center justify-center border cursor-pointer ${
                  activeTab === "prescription" ? "text-white bg-[#189FAA]" : ""
                }`}
                onClick={() => setActiveTab("prescription")}
              >
                <LiaPrescriptionSolid className="w-5 h-5" />
              </p>
              <p
                className={`rounded-full w-8 h-8 flex items-center justify-center border cursor-pointer ${
                  activeTab === "lab" ? "text-white bg-[#189FAA]" : ""
                }`}
                onClick={() => setActiveTab("lab")}
              >
                <IoFlaskOutline className="w-5 h-5" />
              </p>
            </div>
          </div>
          <img
            src={view}
            onClick={handleClick}
            alt="View"
            className="w-7 h-7 cursor-pointer"
          />
        </div>
        <div className="max-h-[300px] overflow-y-auto scrollWidth pr-1">
          {activeTab === "prescription" && (
            <div>
              {prescriptionsList &&
                prescriptionsList?.map((pres, i) => (
                  <PrescriptionCard
                    pres={pres}
                    aptid={pres.appointmentId}
                    date={pres.consultationDate}
                    name={pres.patientName}
                    doctor={pres.userName}
                    reason={pres.consultationReason}
                    clinic={pres.clinic_Name}
                    canJoin={true}
                    patientImage={profileImage}
                    doctorImage="https://randomuser.me/api/portraits/men/75.jpg"
                  />
                ))}
            </div>
          )}
          {activeTab === "lab" && (
            <div>
              {labData &&
                labData?.map((lab, i) => (
                  <div className="bg-white shadow rounded-xl border mb-4">
                    <div className="flex items-center justify-between p-3 border-b">
                      <span className="text-xs font-sans text-[#333333] font-semibold">
                        {lab.patientName}
                      </span>
                      <span className="text-xs font-sans text-[#333333] font-semibold">
                        {lab.labTestOrderId}
                      </span>
                      {lab.resultDocumentName ? (
                        <button
                          onClick={() => handleLabRepView(lab)}
                          className="w-28 h-6 bg-[#189FAA] text-white font-sans font-medium text-xs rounded-md"
                        >
                          View report
                        </button>
                      ) : (
                        <button className="w-28 h-6 bg-gray-400 cursor-not-allowed text-white font-sans font-medium text-xs rounded-md">
                          View report
                        </button>
                      )}
                    </div>
                    <div className="p-3 space-y-2">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Name of the test:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {lab.labTestName}
                        </p>
                      </div>
                      <div className="flex gap-3">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Diagnostics Name:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {lab.vendorName}
                        </p>
                      </div>
                      <hr />
                      <span className="flex items-center gap-2 text-xs font-medium font-sans text-[#333333]">
                        {formatDate(lab?.uploadedDateTime)}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
      <Modal
        open={selectedLabRep.modal}
        onCancel={handleLabModalClose}
        footer={[]}
        destroyOnClose
        width={"70%"}
      >
        <embed
          src={process.env.REACT_APP_IMAGE_URL + selectedLabRep.data}
          type="application/pdf"
          width="100%"
          height="550px"
        />
      </Modal>
    </>
  );
}

export default MedicalRecords;
